/**
 * Dimension size tokens.
 *
 * Numeric size tokens intentionally reuse the spacing unit math so dimension
 * numbers and size tokens stay aligned at 0.25rem per step, while named,
 * fractional, content, and viewport sizes stay first-class token values.
 *
 * @module @smoothie-framework/ui-core/tokens
 */
import { POSITIVE_SPACING_STEPS, spacingValue } from './spacing';
export const NUMERIC_SIZE_STEPS = [
    ...POSITIVE_SPACING_STEPS,
];
const NAMED_SIZE_VALUES = {
    '3xs': '14rem',
    '2xs': '16rem',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    full: '100%',
    min: 'min-content',
    max: 'max-content',
    fit: 'fit-content',
    prose: '60ch',
    vw: '100vw',
    vh: '100vh',
    dvw: '100dvw',
    dvh: '100dvh',
    svw: '100svw',
    svh: '100svh',
    lvw: '100lvw',
    lvh: '100lvh',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    '1/12': '8.333333%',
    '2/12': '16.666667%',
    '3/12': '25%',
    '4/12': '33.333333%',
    '5/12': '41.666667%',
    '6/12': '50%',
    '7/12': '58.333333%',
    '8/12': '66.666667%',
    '9/12': '75%',
    '10/12': '83.333333%',
    '11/12': '91.666667%',
};
const NUMERIC_SIZE_VALUES = Object.fromEntries(NUMERIC_SIZE_STEPS.map((step) => [String(step), spacingValue(step)]));
export const sizes = Object.freeze({
    ...NUMERIC_SIZE_VALUES,
    ...NAMED_SIZE_VALUES,
});
const SIZE_TOKEN_SET = new Set(Object.keys(sizes));
export function isSizeToken(value) {
    return SIZE_TOKEN_SET.has(value);
}
export function sizeValue(token) {
    return sizes[token];
}
export const SIZE_TOKEN_KEYS = Object.freeze(Object.keys(sizes).sort());
//# sourceMappingURL=sizes.js.map